import React, { useState } from "react";
import { APP_DOMAIN, CHOOSE_COLOR, COVERLETTER_EXPERIENCE } from "../../constants/constants";
import { useHistory } from 'react-router-dom';
import { CommingSoonSection } from "./CommingSoonSection";
export  const NoResumeFound = () =>{
    const history = useHistory();
    const handleCreateResume = () => {
        history.push(CHOOSE_COLOR);
      };
      const handleCreateCoverletter = () => {
        history.push(COVERLETTER_EXPERIENCE);
      };
    return(
        <>
            <div className="no-resume-main-container">
                <div className='create-btn'>
                    <div className="create-new-resume blue" onClick={handleCreateResume}>
                    <span>+ Create New Resume</span>
                    </div>
                    <div className="create-new-resume teal" onClick={handleCreateCoverletter}>
                    <span>+ Create New Cover Letter</span>
                    </div>
                </div>
                <div className="list-container">
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/AI.svg`}
                                alt="AI resume assistant"
                            />
                        </div>
                        <div className="info">
                            <h3>Get Started in Just a Few Clicks</h3>
                            <p>Our AI-powered resume builder makes the process simple. Choose a template, add details, and let AI refine your content for clarity and impact.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/ATS.svg`}
                                alt="Browse professional resume templates"
                            />
                        </div>
                        <div className="info">
                            <h3>ATS-Optimized Designs</h3>
                            <p>Ensure your resume passes applicant tracking systems (ATS) and gets in front of hiring managers.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/font-color.svg`}
                                alt="Customize your resume design"
                            />
                        </div>
                        <div className="info">
                            <h3>Smart Recommendations</h3>
                            <p>Get AI-driven suggestions for phrasing, keyword optimization, and formatting that help your resume stand out.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/search.svg`}
                                alt="Find inspiration from sample resumes"
                            />
                        </div>
                        <div className="info">
                            <h3>Personalize and Optimize</h3>
                            <p>Tailor phrasing to fit specific industries and experience levels and match job descriptions with the right keywords.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/newATS.svg`}
                                alt="ATS-optimized layouts"
                            />
                        </div>
                        <div className="info">
                            <h3> Job-Specific Suggestions</h3>
                            <p>Highlight relevant achievements based on the target role.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/personal.svg`}
                                alt="Expert tips at every step"
                            />
                        </div>
                        <div className="info">
                            <h3>Download and Apply with Confidence</h3>
                            <p>Export your resume in multiple formats, making it easy to apply for jobs anytime, anywhere.</p>
                        </div>
                    </div>
                </div>
                {/* <div className='create-btn'>
                    <div className="create-new-resume" onClick={handleCreateResume}>
                    <span>+ Start a New Resume</span>
                    </div>
                    <div className="create-new-resume" onClick={handleCreateCoverletter}>
                    <span>+ Start a New Coverletter</span>
                    </div>
                </div> */}

                <CommingSoonSection />
            </div>
        </>
    );
}   